import type { ReactNode } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

import type { LookupOption } from '@/lib/api/schemas';

import { Fieldset } from './field';

interface ChoiceGroupProps {
  type: 'radio' | 'checkbox';
  name: string;
  legend: ReactNode;
  options: readonly LookupOption[];
  registration: UseFormRegisterReturn;
  error?: string | undefined;
  hint?: ReactNode;
  size?: 'md' | 'lg';
  inline?: boolean;
}

/** Radios or checkboxes registered with react-hook-form; checkbox groups yield string[]. */
export function ChoiceGroup({
  type,
  name,
  legend,
  options,
  registration,
  error,
  hint,
  size = 'md',
  inline = false,
}: ChoiceGroupProps) {
  return (
    <Fieldset legend={legend} hint={hint} error={error} errorId={`${name}-error`} size={size}>
      <div className={`choice-list${inline ? ' choice-list--inline' : ''}`}>
        {options.map((o) => (
          <label key={o.value} className="choice">
            <input type={type} value={o.value} {...registration} />
            <span>{o.label}</span>
          </label>
        ))}
      </div>
    </Fieldset>
  );
}
